import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32060984"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32060984')) {
      api.createRecord('32060984', component.options)
    } else {
      api.reload('32060984', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32060984", function () {
      api.rerender('32060984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/import/history/index.vue"
export default component.exports